import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Segment, Button, Message } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { updateAdjustmentModelInStore, createInventoryAdjustment } from "../../../actions/inventory";
import Dls from "../../../lib";

class InventoryAdjustmentForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false,
            transfer: false
        };
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .createInventoryAdjustment(this.props.jwt, this.props.model)
                .then(res => {
                    this.setState({
                        loading: false
                    }, () => {
                        this.props.inventoryAdjusted();
                    })
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { fromWarehouse,toWarehouse,id,changeQty } = this.props.model;
        const {transfer} = this.state;
        const errors = [];
        if (!toWarehouse) {
            errors.push(transfer ? "Must select a to warehouse" : "Must select a warehouse");
        }
        if (transfer) {
            if (!fromWarehouse) {
                errors.push("Must select a from warehouse in a transfer");
            }
            if (_.toInteger(changeQty) <= 0) {
                errors.push("Quantity must be a postive integer");
            }
            if (fromWarehouse === toWarehouse) {
                errors.push("Two warehouses cannot be the same");
            }
        } else {
            if (_.toInteger(changeQty) === 0) {
                errors.push("Quantity must be an positive or negative integer");
            }
        }

        return errors;
    };

    onTransferClicked = (data) => {
        this.props.updateAdjustmentModelInStore('fromWarehouse', "");
        this.setState({transfer: data.checked});
    }
    
    render() {
        const {model, updateAdjustmentModelInStore, warehouses} = this.props;
        return (
            <Form size="large">
                <Segment stacked>
                    {!this.state.transfer ? <Message 
                        info
                        header="What's quantity change (Non-Transfer)?"
                        content="Quantity change is the difference or discrepencies between your new inventory quantities and the 
                        current inventory quantities. It should be a negative integer if you are going to deduct current inventory.
                        On the other hand, it should be a positive integer if you are going to increase current inventory.
                        "
                    /> : null}
                    {this.state.transfer ? <Message 
                        info
                        header="What's quantity change (Warehouse Transfer)?"
                        content='Quantity change should be a positive integer. It is the number of units you are moving out from the 
                        "From Warehouse". The system will automatically deduct this quantity from the "From Warehosue" and increase the 
                        quantity to the "To Warehouse".
                        '
                    /> : null}
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    <Form.Checkbox
                        label="Create A Warehouse Transfer"
                        name="transfer"
                        onChange={(e,data) => { this.onTransferClicked(data) }}
                        checked={this.state.transfer}
                    />
                    {this.state.transfer ? <Form.Select fluid label='From Warehouse' options={warehouses} 
                        name="fromWarehouse" value={model.fromWarehouse ? model.fromWarehouse : "Active"} 
                        onChange={(e,data) => { updateAdjustmentModelInStore('fromWarehouse', data.value) }}
                    /> : null}
                    <Form.Select fluid label={this.state.transfer ? 'To Warehouse' : 'Warehouse'} options={warehouses} 
                        name="toWarehouse" value={model.toWarehouse ? model.toWarehouse : "Active"} 
                        onChange={(e,data) => { updateAdjustmentModelInStore('toWarehouse', data.value) }}
                    />
                    <Form.Input 
                            fluid 
                            type='number'
                            label="Quantity Change"
                            name="changeQty"
                            value={model.changeQty ? model.changeQty : ""} 
                            onChange={(e) => { updateAdjustmentModelInStore(e.target.name, e.target.value) }}
                        />
                    <Button
                        color="teal"
                        onClick={this.onFormSubmit}
                        size="tiny"
                        loading={this.state.loading}
                        disabled={this.state.loading}
                    >
                        Save
                    </Button>
                    <Button
                        color="red"
                        onClick={() => this.props.onModalClose()}
                        size="tiny"
                        floated="right"
                    >Cancel</Button>
                </Segment>
            </Form>
        );
    }
}

InventoryAdjustmentForm.propTypes = {
    updateAdjustmentModelInStore: PropTypes.func.isRequired,
    createInventoryAdjustment: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired,
    onModalClose: PropTypes.func.isRequired,
    inventoryAdjusted: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.inventory.adjustment,
        warehouses: state.system.resources.warehouses,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateAdjustmentModelInStore,
            createInventoryAdjustment
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryAdjustmentForm);



// WEBPACK FOOTER //
// ./src/components/forms/inventories/Adjustment.js